import React, { useEffect, useState } from "react";
import "./Screen.css";
import { TypeAnimation } from "react-type-animation";
import { Link } from 'react-router-dom';
import img1 from "../img/1.png";
import img2 from "../img/2.png";
import img3 from "../img/3.png";
import img4 from "../img/4.png";
import img5 from "../img/5.png";


function Screen() {
const images = [
  
  img5,
  img4,
  img3,
  img2,
  img1,
];
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const scrollStep = () => {
    window.scrollBy({
      top: window.innerHeight,
      behavior: "smooth",
    });
  };

  return (
    <section className="hero">
      {images.map((img, index) => (
        <div
          key={index}
          className={`hero-slide ${index === currentImage ? "active" : ""}`}
          style={{
            backgroundImage: `url(${img})`,
          }}
        />
      ))}

      <div className="overlay"></div>

      <div className="hero-content">
        <span className="hero-badge">
          בניית אתרים • דפי נחיתה • קידום עסקים
        </span>

        <h1>
          מקימים לעסק שלך
          <br />
          נוכחות דיגיטלית שמביאה לקוחות
        </h1>

        <TypeAnimation
          sequence={[
            "אתר תדמית מקצועי לעסק שלך",
            2000,
            "עיצוב מודרני שמייצר אמון",
            2000,
            "מהיר, רספונסיבי ומותאם לנייד",
            2000,
            "פתרון איכותי גם לעסקים קטנים",
            2000,
          ]}
          speed={60}
          repeat={Infinity}
          className="typing-text"
        />

        <div className="hero-buttons">
          <Link to="/Contact" className="btn-primary" onClick={scrollStep} >
            קבל הצעת מחיר
          </Link>

    <Link to="/Mysite" className="btn-secondary" onClick={scrollStep} >
  עבודות אחרונות
</Link>
        </div>

<button className="scroll-down" onClick={scrollStep}>
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none">
    <path
      d="M6 9l6 6 6-6"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
</button>
      </div>
    </section>
  );
}

export default Screen;